// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_0MQ","cls2":"UpsellModalRedesign-cls2_08h UpsellModalRedesign-cls1_0MQ"};